import { useState, useCallback } from 'react'

type ReturnProps = [boolean, (value?: boolean) => void]

const useToggle = (initial = false): ReturnProps => {
  const [state, setState] = useState(initial)

  const toggle = useCallback(
    (value?: boolean) =>
      setState((prev) =>
        value !== undefined && typeof value === 'boolean' ? value : !prev
      ),
    []
  )

  return [state, toggle]
}

export default useToggle
